import React from "react";
import { MailIcon } from "@heroicons/react/solid";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";

const a1 = require("../assets/images/1a.png");
const a2 = require("../assets/images/a5.png");
const b1 = require("../assets/images/b1.png");
const b2 = require("../assets/images/b2.png");
const c1 = require("../assets/images/c1.png");
const c2 = require("../assets/images/c2.png");
const c3 = require("../assets/images/c3.png");
const c4 = require("../assets/images/c4.png");
const d1 = require("../assets/images/d1.png");
const d2 = require("../assets/images/d2.png");
const g1 = require("../assets/images/g1.png");
const g2 = require("../assets/images/g2.png");
const g3 = require("../assets/images/g3.png");
const movie = require("../assets/images/movie.png");
const wrodl = require("../assets/images/Wordle-Emblem.png");
const capstoneImage = require("../assets/images/capstoneImage.png");

const projectsData = [
  {
    title: "Large Group Eye Tracking Live Analytics",
    description:
      "Capstone project exploring group eye tracking in classroom settings to better understand student attention and engagement. Using data from eye-tracking goggles, the system processes gaze information in real time and displays analytics on an instructor dashboard. The platform supports both live visualizations and post-session analysis, featuring real-time streaming analytics, homography transformations, and dynamic heatmap generation for comprehensive gaze pattern analysis.",
    technologies: [
      "Python",
      "Apache Kafka",
      "React",
      "Real-Time Streaming",
      "Homography",
      "Heatmaps",
      "Data Analytics",
    ],
    imageUrls: [capstoneImage],
  },
  {
    title: "StockVision: Machine Learning Market Predictor",
    description:
      "Designed and trained time-series machine learning models (LSTMs, GRUs) using Python and PyTorch, with additional model experimentation in C++/TensorFlow, to forecast short-term stock price movements; deployed inference pipelines on AWS EC2/S3 for real-time prediction and visualization.",
    technologies: [
      "Python",
      "PyTorch",
      "LSTMs",
      "GRUs",
      "C++",
      "TensorFlow",
      "AWS EC2",
      "AWS S3",
    ],
    imageUrls: [],
  },
  {
    title: "MovieWiz",
    description: "Developed a movie recommendation system, utilizing Python, PyTorch and Google Colab. Leveraged Machine Learning techniques on the IMDb dataset to analyze information and train the model. Utilized AWS’ DynamoDB and Cognito for storage and user authentication.",
    technologies: [
      "Python",
      "PyTorch",
      "tensorflow",
      "Machine Learning",
      "AWS DynamoDB",
      "AWS Cognito",
      "Google Colab",
    ],
    imageUrls: [movie],
  },
  {
    title: "SecureLink",
    description:
      "Developed a secure chat application with end-to-end encryption using Java, React Native, TypeScript, and Android Studio. Utilized Firebase for database management, user authentication, and encrypted message transmission. Implemented MVC architectural pattern for structured, scalable codebase, with comprehensive documentation for maintenance and future enhancements. ",
    technologies: [
      "React Native",
      "Typescript",
      "Java",
      "Node.js",
      "Firebase",
      "Android Studio",
    ],
    imageUrls: [a2, a1],
  },
  {
    title: "BudgetEz: Finance Tracker",
    description:
      "Developed a comprehensive budget tracker application named BudgetEz, utilizing the MERN stack (MongoDB, Express.js, React, Node.js). Integrated Clerk for secure user authentication. Enabled users to input income and expenses, displaying data to assist in effective budgeting. Implemented dynamic insights and analytics to provide users with actionable financial insights. Ensured a structured, maintainable, and scalable codebase with thorough documentation for seamless maintenance and future enhancements.",
    technologies: ["React", "Express.js", "MongoDB", "Node.js"],
    imageUrls: [g1, g2, g3],
  },
  {
    title: "Habit Spark: Habit Tracker",
    description:
      "Created a Habit Tracking Chrome extension using React, TypeScript, CSS, and JavaScript. The extension aids users in monitoring and improving their habits. Utilized Google Chrome storage for secure data storage, ensuring persistence across sessions, and implemented an intuitive and visually appealing UI.",
    technologies: ["React", "Typescript", "CSS", "Google Storage"],
    imageUrls: [b1, b2],
  },
  {
    title: "Mesh and Island Generator",
    description:
      "Created a Java-based software suite leveraging Apache Maven to generate and visualize 2D meshes for 3D graphics, including randomized islands and biomes. Integrated pathfinding algorithms such as Dijkstra’s, DFS, and BFS. Employed an incremental development approach aligned with the software development lifecycle, managing technical debt effectively. Ensured quality with Junit for comprehensive unit testing, addressing defects promptly to maintain robustness.",
    technologies: ["Java", "Apache Maven", "JUnit"],
    imageUrls: [c1, c2, c3, c4],
  },
  {
    title: "Sorting Visualizer",
    description:
      "Created a Sorting Visualizer web application using JavaScript, HTML, and CSS to demonstrate sorting algorithms such as bubble sort, merge sort, and quicksort dynamically. Users can add random bars, select an algorithm, and visually track the sorting process in real-time through an interactive interface. Designed for clarity and educational value, the project provides a hands-on experience to enhance understanding of sorting principles.",
    technologies: ["Javascript", "HTML", "CSS"],
    imageUrls: [d1, d2],
  },
  {
    title: "Wordle Solver",
    description:
      "Developed a Python-based Wordle solver software that analyzes letter patterns and generates solutions through iterative guessing and feedback. Implemented using object-oriented programming principles for clarity and maintainability, with an incremental development approach ensuring scalability and performance. This approach facilitated feature additions and optimizations, resulting in a reliable solver for solving Wordle puzzles effectively.",
    technologies: ["Python"],
    imageUrls: [wrodl],
  },
];

const Projects = () => {
  return (
    <div id="Projects" className="pb-72 mt-20">
      <div className="mx-6 sm:mx-12 lg:mx-60">
        <MailIcon className="h-5 w-5 mr-4 text-yellow_vs" />
        <code className="text-[#e6f1ff] text-2xl sm:text-3xl mt-5 whitespace-nowrap block">
          MY PROJECTS
        </code>
        <div className="border-b border-[#e6f1ff] border-opacity-25 w-full mt-5 mb-10"></div>
      </div>
      <div className="mx-6 sm:mx-12 lg:mx-60">
        {projectsData.map((project, index) => (
          <div key={index} className="bg-[#1a1a1a] p-4 sm:p-6 lg:p-8 rounded-xl mb-8 sm:mb-12 overflow-hidden">
            {/* Image section - on top */}
            {project.imageUrls.length > 0 && (
            <div className="mb-4 sm:mb-6 rounded-lg overflow-hidden bg-[#252525]">
              <Carousel
                showArrows={true}
                dynamicHeight={false}
                infiniteLoop={true}
                showThumbs={false}
                showStatus={project.imageUrls.length > 1}
              >
                {project.imageUrls.map((imageUrl, idx) => (
                  <div key={idx} className="flex items-center justify-center" style={{ minHeight: "200px" }}>
                    <img
                      src={imageUrl}
                      alt={`${project.title} ${idx + 1}`}
                      style={{
                        maxHeight: "450px",
                        width: "100%",
                        objectFit: "contain",
                      }}
                    />
                  </div>
                ))}
              </Carousel>
            </div>
            )}
            {/* Text content */}
            <div>
              <h2 className="text-xl sm:text-2xl font-semibold text-[#e6f1ff] mb-2 sm:mb-3">
                {project.title}
              </h2>
              <p className="text-[#a2aabc] text-sm sm:text-base mb-4 sm:mb-5 leading-relaxed">{project.description}</p>
              <h3 className="text-base sm:text-lg text-[#e6f1ff] mb-2 sm:mb-3">
                Technologies Used:
              </h3>
              <div className="flex flex-wrap gap-1.5 sm:gap-2">
                {project.technologies.map((tech, idx) => (
                  <span
                    key={idx}
                    className="bg-[#2d2d2d] text-[#a2aabc] px-2 sm:px-3 py-0.5 sm:py-1 rounded-full text-xs sm:text-sm border border-[#3d3d3d]"
                  >
                    {tech}
                  </span>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Projects;
